export const getItem = item => localStorage.getItem(item);

export const removeItem = item => localStorage.removeItem(item);

export const setItem = (item, value) => localStorage.setItem(item, value);
